import { RouteConfig } from "vue-router";
import { safeImport } from "@/utils/SafeImport";

const routes: Array<RouteConfig> = [
  {
    path: "*",
    name: "not_found",
    component: safeImport(
      () => import(/* webpackChunkName: "route.not-found" */ "../views/404.vue")
    ),
  },
  {
    path: "/unsubscribe-notifications",
    name: "unsubscribe_notifications",
    component: safeImport(
      () =>
        import(
          /* webpackChunkName: "route.unsubscribe-notifications" */ "../views/NotificationsUnsubscribe.vue"
        )
    ),
  },
];

export default routes;
